import { Link } from "react-router-dom";
import { heroAnchors, site } from "@/mocks/site";
import { articles } from "@/mocks/articles";

const featured = articles[0];

export default function HeroSection() {
  return (
    <section className="relative w-full">
      <div className="relative h-[460px] w-full overflow-hidden md:h-[560px]">
        <img
          src="https://readdy.ai/api/search-image?query=Grand%20beauty%20pageant%20stage%20with%20warm%20golden%20spotlights%2C%20red%20velvet%20curtains%20and%20elegant%20evening%20gowns%20arranged%20in%20a%20row%2C%20dramatic%20editorial%20photography%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=hero-stage-01&orientation=landscape"
          alt="选美比赛舞台与暖金色灯光现场"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/30" />

        <div className="absolute inset-0 flex items-center">
          <div className="mx-auto w-full max-w-content px-4 md:px-6">
            <div className="max-w-2xl animate-rise">
              <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary-300/50 bg-primary-500/20 px-3 py-1 text-xs text-background-100 backdrop-blur">
                <span className="inline-flex h-4 w-4 items-center justify-center">
                  <i className="ri-live-line text-accent-400 animate-pulse-soft" />
                </span>
                本季焦点 · 翻车现场持续更新
              </p>
              <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
                {site.brand} · 围观选美现场的每一次意外
              </h1>
              <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
                {site.tagline}。淘汰尴尬、即兴失误、评委表情、选手反应，我们把散落在各大赛事里的现场碎片，整理成一条完整可读的吃瓜时间线。
              </p>

              <div className="mt-8 flex flex-wrap items-center gap-3">
                <Link
                  to={`/article/${featured.id}`}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <span className="inline-flex h-4 w-4 items-center justify-center">
                    <i className="ri-play-circle-line" />
                  </span>
                  先看本期焦点名场面
                </Link>
                <a
                  href="#categories"
                  className="whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm text-background-50 transition-colors hover:bg-background-50/10"
                >
                  浏览全部栏目
                </a>
              </div>

              <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-background-300">
                <span className="flex items-center gap-1.5">
                  <span className="inline-flex h-4 w-4 items-center justify-center text-accent-400">
                    <i className="ri-article-line" />
                  </span>
                  已整理 120+ 个现场片段
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="inline-flex h-4 w-4 items-center justify-center text-accent-400">
                    <i className="ri-time-line" />
                  </span>
                  赛事密集期每周更新
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav aria-label="页面锚点导航" className="border-b border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-content items-center gap-1 overflow-x-auto px-4 py-2 md:px-6">
          {heroAnchors.map((anchor) => (
            <a
              key={anchor.href}
              href={anchor.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200 hover:text-primary-700"
            >
              {anchor.label}
            </a>
          ))}
        </div>
      </nav>
    </section>
  );
}